import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-vendors-importer',
  templateUrl: './vendors-importer.component.html',
  styleUrls: ['./vendors-importer.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorsImporterComponent {}
